type State = {
  isPortfolioLoading: boolean;
  selectedSiteId: number | string | null;
};

const state: State = {
  isPortfolioLoading: false,
  selectedSiteId: null,
};

const mutations = {
  SetIsPortfolioLoading(state: State, isLoading: boolean) {
    state.isPortfolioLoading = isLoading;
  },
  SetSelectedSiteId(state: State, siteId: number | string) {
    state.selectedSiteId = siteId;
  },
};

const getters = {
  getIsPortfolioLoading: (state: State) => state.isPortfolioLoading,
  getSelectedSiteId: (state: State) => state.selectedSiteId,
};

export default {
  namespaced: true,
  state,
  // actions,
  getters,
  mutations,
};
